import React from 'react';

import { Map } from 'mapbox-gl';
import { addGeolocationTo, GeolocationControl } from 'map-gl-geolocation';

import 'mapbox-gl/dist/mapbox-gl.css';
import 'map-gl-geolocation/dist/map-gl-geolocation.css';

const accessToken
    = 'pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4M29iazA2Z2gycXA4N2pmbDZmangifQ.-g_vE53SD2WrJ6tFX7QHmA';

type Props = {
    style: object
}
class SimpleMap extends React.Component<Props> {
    map: any;
    mapContainer: any;

    componentDidMount() {

        this.map = new Map({
            accessToken,
            container: this.mapContainer,
            style: 'https://vector.getwemap.com/styles/wemap-v1-fr.json',
            center: [2.35, 48.85],
            zoom: 12
        });

        addGeolocationTo(this.map);

        this.map.addControl(new GeolocationControl());
    }

    componentWillUnmount() {
        this.map.remove();
    }

    updatePosition(position: any) {
        if (this.map && this.map.geolocation) {
            this.map.geolocation.position = position;
        }
    }

    updateAttitude(attitude: any) {
        if (this.map && this.map.geolocation) {
            this.map.geolocation.heading = attitude ? attitude.headingDegrees : null;
        }
    }

    updateHeading(heading: any) {
        if (this.map && this.map.geolocation) {
            this.map.geolocation.heading = typeof heading === 'number' ? heading : null;
        }
    }

    render() {
        return (
            <div ref={map => (this.mapContainer = map)}
                style={this.props.style} />
        );
    }
}

export default SimpleMap;
